export default {
    version: 'v2.0'
}
